export default {"src":"/_next/static/media/Group-254996-1.2c1277cb.svg","height":126,"width":126};